import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ApplicationForm from './ApplicationForm'; 
import Buzz2BrainHallOfFame from "./Buzz2BrainHallOfFame";
import { logout } from '../../redux/actions/authActions';

const Buzz2Brain = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/buzz2brain");
  };

  const features = [
  {
    title: "Fantasy-Style Learning",
    emoji: "🎮",
    desc: "Compete just like in Dream11 – but for your brain, not cricket."
  },
  {
    title: "Weekly Micro-Learning",
    emoji: "📘",
    desc: "Every week, dive into a trending buzzword through a ₹20 micro-book."
  },
  {
    title: "Leaderboard Rankings",
    emoji: "📊",
    desc: "Climb the leaderboard based on quiz scores, notes, and reflection."
  },
  {
    title: "BuzzSquads & Teams",
    emoji: "👥",
    desc: "Form or join teams to compete together and win monthly team rewards."
  },
  {
    title: "Guaranteed Rewards",
    emoji: "🏆",
    desc: "Top 21,500+ scorers every month win scholarships worth ₹50 lakh."
  },
  {
    title: "Participation Bonuses",
    emoji: "🎁",
    desc: "Earn badges, lucky draw rewards, and streak bonuses for consistency."
  },
  {
    title: "Fair Play Engine",
    emoji: "🛡️",
    desc: "Single attempt quizzes, randomized questions, and anti-cheating tech."
  },
  {
    title: "Teasers & Interviews",
    emoji: "🎤",
    desc: "Top scorers featured weekly with sneak peeks into next week’s buzz."
  },
  {
    title: "Weekly Edutainment at ₹20 + GST",
    emoji: "💡",
    desc: "Transform your ₹20 into knowledge, fun, and real-world rewards!"
  }
];

const prizeData = [
  { category: '🥇 Topper', rank: 'Rank 1', winners: 1, reward: '₹10,00,000', total: '₹10,00,000' },
  { category: '🥈 IMElite', rank: 'Top 2 – 10', winners: 9, reward: '₹50,000', total: '₹4,50,000' },
  { category: '🥉 IMAchievers', rank: 'Rank 11 – 101', winners: 91, reward: '₹5,000', total: '₹4,55,000' },
  { category: '🏅 IMPerformers', rank: 'Rank 102 – 1,001', winners: 900, reward: '₹1,000', total: '₹9,00,000' },
  { category: '🎖️ IMMeritStars', rank: 'Rank 1,002 – 10,001', winners: 9000, reward: '₹100', total: '₹9,00,000' },
  { category: '💠 IMConsolation', rank: 'Rank 10,002 – 20,001', winners: 10000, reward: '₹50', total: '₹5,00,000' },
  { category: '🎁 Lucky 500', rank: 'Random from rest', winners: 500, reward: '₹200', total: '₹1,00,000' },
  { category: '🛡️ Reserve Fund', rank: 'Emergency / Carry Forward', winners: '—', reward: '—', total: '₹5,00,000' },
];


  return (
    <div className="font-sans text-gray-800 bg-gray-100">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-teal-700 shadow-md sticky top-0 z-50">
        <div className="text-3xl font-extrabold text-yellow-200 tracking-wide">Buzz2Brain</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium text-gray-700">
          <a href="#prizes" className="text-white hover:text-yellow-200 transition">Prizes</a>
          <Link to="/buzz2brain-updates" className="text-white hover:text-yellow-200 transition">Updates</Link>
          <a href="#whyus" className="text-white hover:text-yellow-200 transition">About Buzz2Brain</a>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-yellow-200 font-medium">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/buzz2braindashboard`)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition"
                title="Dashboard"
              >
                🏠
              </button>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-teal-500 text-teal-600 rounded-full hover:bg-teal-50 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-teal-600 text-white rounded-full hover:bg-teal-700 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-3xl text-teal-600 focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-1 text-center shadow-md">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-teal-600 font-medium">Welcome, {userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={() => navigate(`/buzz2braindashboard`)}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-teal-500 text-white rounded-full hover:bg-teal-600 transition"
                >
                  🏠
                </button>
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          <a href="#prizes" className="text-white hover:text-yellow-200 transition">Prizes</a>
          <Link to="/buzz2brain-updates" className="block hover:text-teal-600">Updates</Link>
          <a href="#whyus" className="block hover:text-teal-600">About Buzz2Brain</a>

          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-teal-500 text-teal-600 rounded-full hover:bg-teal-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-teal-600 text-white rounded-full hover:bg-teal-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
      <section 
        className="relative min-h-[60vh] sm:min-h-[70vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/assets/banners/buzz2brain.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center px-4 sm:px-6 md:px-8">
          <h1 className="text-xl sm:text-3xl lg:text-3xl font-bold mb-4 leading-tight">
            Think5Whys Buzz2Brain Fantasy Leauge
          </h1>
          <p className="text-lg sm:text-xl text-white mb-4 font-semibold">
            From What’s Buzzing to What’s Winning – Weekly
          </p>

          {/* Responsive Button Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 max-w-3xl mx-auto">
            {[
              { label: "BuzzWord Knowledge", link: "/buzz2brainbookworld" },
              // { label: "Practice", link: "/buzz2brain-home" },
              { label: "Quizz", link: "/buzz2brain-quizz" },
              { label: "Leaderboard", link: "/buzz2brain-leaderboard" },
              { label: "Buzz2Word Hall Of Fame", link: "/buzz2brain-halloffame" },
            ].map((btn, idx) => (
              <button
                key={idx}
                onClick={() => window.location.href = btn.link}
                className="w-full px-4 py-3 text-base sm:text-lg font-semibold bg-teal-600 rounded-lg hover:bg-teal-700 hover:text-yellow-200 transition"
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Buzz2Brain Hall Of Fame */}
      <Buzz2BrainHallOfFame />

      <section id="whyus" className="py-16 px-6 md:px-20 bg-gradient-to-r from-teal-700 to-indigo-600">
        <h2 className="text-4xl font-bold text-center mb-12 text-white">Why Buzz2Brain?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 text-center text-white">
          {features.map((feature, idx) => (
            <div key={idx} className="bg-white/10 p-8 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
              <div className="text-6xl mb-5">{feature.emoji}</div>
              <h4 className="text-2xl font-semibold mb-3">{feature.title}</h4>
              <p className="text-lg">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Vision, Mission & Values */}
      <section id="vision" className="py-16 px-6 md:px-20 bg-gradient-to-r from-purple-700 to-pink-800 text-white">
        <h2 className="text-4xl font-bold text-center mb-12">Vision, Mission & Values</h2>
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="bg-white/10 p-8 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-2xl font-semibold mb-3">🌟 Vision</h3>
            <p className="text-lg">
              To spark the minds of millions of thinkers from diversified areas and genre every week, nurturing a global culture of curiosity, creativity, and competitive cognition—through fun, gamified learning.
            </p>
          </div>
          <div className="bg-white/10 p-8 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-2xl font-semibold mb-3">🎯 Mission</h3>
            <ul className="list-disc list-inside text-lg space-y-3">
              <li>Create a weekly buzz of millions of participants through brain-challenging games and wordplay.</li>
              <li>Introduce meaningful rewards and fantasy-league-style leaderboards to keep motivation high.</li>
              <li>Provide micro-learning that builds deep thinking habits in just a few minutes a day.</li>
              <li>Make knowledge fun, accessible, and socially shareable for learners of all ages.</li>
            </ul>
          </div>
          <div className="bg-white/10 p-8 rounded-xl shadow-lg backdrop-blur-lg hover:bg-white/20 transition">
            <h3 className="text-2xl font-semibold mb-3">💡 Core Values</h3>
            <ul className="list-disc list-inside text-lg space-y-3">
              <li><strong>Curiosity</strong> — Fueling the desire to explore and question everything.</li>
              <li><strong>Playfulness</strong> — Making learning fun, fast, and fulfilling.</li>
              <li><strong>Competitiveness</strong> — Channeling friendly rivalry to push mental boundaries.</li>
              <li><strong>Inclusiveness</strong> — Encouraging participation from all geographies and age groups.</li>
              <li><strong>Agility</strong> — Rapid thinking, fast learning, instant action.</li>
              <li><strong>Wisdom</strong> — Turning knowledge into insight, and insight into impact.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Prizes Section */}
      <section className="bg-white py-10 px-4 sm:px-8 md:px-16" id="prizes">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
            🎓 Prizes
          </h2>
          <p className="text-center text-lg text-gray-600 mb-8">
            💸 <strong>Total Monthly Scholarship Pool:</strong> ₹50,00,000
          </p>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-blue-600 border border-gray-200 rounded-lg shadow-sm">
              <thead className="bg-blue-200">
                <tr>
                  <th className="px-4 py-3 border text-left text-sm font-semibold text-gray-700">🎖️ Category</th>
                  <th className="px-4 py-3 border text-left text-sm font-semibold text-gray-700">🧠 Rank / Percentile</th>
                  <th className="px-4 py-3 border text-center text-sm font-semibold text-gray-700">👥 Winners</th>
                  <th className="px-4 py-3 border text-right text-sm font-semibold text-gray-700">💰 Reward / Student</th>
                </tr>
              </thead>
              <tbody>
                {prizeData.map((item, idx) => (
                  <tr key={idx} className="hover:bg-blue-800 transition">
                    <td className="px-4 py-3 border text-sm">{item.category}</td>
                    <td className="px-4 py-3 border text-sm">{item.rank}</td>
                    <td className="px-4 py-3 border text-center text-sm">{item.winners}</td>
                    <td className="px-4 py-3 border text-right text-sm">{item.reward}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>



      {/* Footer */}
      <footer className="bg-teal-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-teal-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-teal-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-teal-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-teal-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Buzz2Brain;
